module.exports = __webpack_public_path__ + "img/portada-inversor.71db469a.webp";